import { CORE_API } from "../constants";
import { getData } from "./common.service";

export type TAppNotif = {
  id: string;
  text: string;
  date: string | Date;
  seen: boolean;
  isImportant: boolean;
  validTill: string | Date;
  notifTypeId: number;
  showPopup: boolean;
  farmUserId: string;
  plotId: string;
};
interface WhereClause {
  plotId: string;
  isImportant?: boolean;
  validTill?: { gt: Date };
}

export type TAppNotifs = Array<TAppNotif>;

class AppNotifService {
  private static readonly baseUrl = "/app-notifs";

  static getLatestFieldData(plotId: string, pageIndex: number = 0, all: boolean = false): Promise<TAppNotifs> {

    const whereClause: WhereClause = {
      plotId: plotId,
    };

    if (!all) {
      whereClause.isImportant = true;
      whereClause.validTill = { gt: new Date() };
    }

    const filterQuery = {
      where: whereClause,
      skip: pageIndex * 10,
      limit: 10,
      order: ["date DESC"],
    };

    const url = `${AppNotifService.baseUrl}?filter=${JSON.stringify(filterQuery)}`;

    return getData(url, {
      sendTokenInHeader: true,
      basePath: CORE_API,
    });
  }
}

export default AppNotifService;